module.exports = __webpack_public_path__ + "ab3ac03c.svg";